<template>
  <div class="meetingroom">
    <sidebar_user :setorders="orders" />
    <section class="home-section">
      <b-container>
        <br />
        <br />
        <div class="calendar-list">
          <div class="card card-order-list card-margin calendar-border">
            <div class="card-body">
              <div class="container">
                <div class="card-content-more">
                  <h1 class="btn-floating">
                    {{ choosedDay2.dateFormat | moment }}
                    <!-- {{ date | moment }} -->
                  </h1>
                </div>
                <!-- :minDate="dateTime" -->
                <vue-horizontal-calendar
                  choosedDate:dateTime
                  v-on:change="dateChange2"
                  lang="en"
                  choosedItemColor="
            rgb(255,95,45)"
                  todayItemColor="rgb(150, 0, 0, .1)"
                  :minDate="dateTime"
                >
                  <img
                    slot="leftIcon"
                    src="../../assets/icons/right.png"
                    style="width: 20px; margin-top: -2px"
                  />
                  <img
                    slot="rightIcon"
                    src="../../assets/icons/left.png"
                    style="width: 20px; margin-top: -2px"
                  />
                </vue-horizontal-calendar>
              </div>
            </div>
          </div>
        </div>
        <!-- ====================================== Room Booked =============================================-->
        <br />

        <div class="time-column">
          <!-- time-column ""-->

          <div class="card-columns">
            <!-- v-for="(std, inx) in history"
              :key="inx" -->
            <!-- ====================================== รายละเอียดการจองห้อง ===========================================-->
            <!-- v-for="(std, inx) in history"
            :key="inx" -->
            <div
              v-for="(std, inx) in history"
              :key="inx"
              class="card card-order-list card-margin border-0 card-service"
            >
              <!-- ====================================  แจ้งแตือนยกเลิก จองห้องเรียบร้อย ================================= -->
              <!-- <div class="card-body" :style="{padding: 2 + 'px',marginTop:5+'px',bottom:-5 +'px'}">
              <h6 class="card-title overtime-detail">
                <i class="fa-solid fa-face-sad-cry" :style="{fontSize:30 +'px',padding:12 +'px',color:'#FF6600'}"></i>
                ห้อง MEETING 3A ของคุณ <b>ยกเลิกแล้ว</b>
              </h6>
            </div> -->

              <!-- ====================================== END ======================================================= -->
              <div class="card-body">
                <div class="card-title">
                  <h5><b>รายละเอียดการจอง</b></h5>
                </div>
                <hr class="ml-2" />

                <!-- v-if="
                    std.room_id === 1 ||
                    std.room_id === 2 ||
                    std.room_id === 3 ||
                    std.room_id === 4 ||
                    std.room_id === 5 ||
                    std.room_id === 6 ||
                    std.room_id === 7
                  "  -->
                <span>
                  <!-- {{ std.room_name}} -->
                  <p class="text-left" style="font-size: 14px">
                    ห้องที่จอง : {{ std.room_name }}
                  </p>
                  <!-- {{ std.whois_std_name }} -->
                  <p class="text-left" style="font-size: 14px">
                    ชื่อผู้จอง : {{ std.whois_std_name }}
                  </p>
                  <!-- {{ std. }} -->
                  <p class="text-left" style="font-size: 14px">
                    รหัสผู้จอง: {{ std.whois_std_code }}
                  </p>
                  <p class="text-left" style="font-size: 14px">
                    สถานะการจอง :
                    <b
                      v-if="std.trans_status === 'booked'"
                      style="
                        padding: 7px;
                        background-color: gray;
                        border-radius: 30px;
                        color: white;
                        font-size: 12px;
                      "
                      >รอยืนยัน</b
                    >
                    <b
                      v-if="
                        std.trans_status === 'inlocker' &&
                        std.locker_number !== ''
                      "
                      style="
                        padding: 6px;
                        background-color: orangered;
                        border-radius: 30px;
                        color: white;
                        font-size: 10px;
                      "
                      >รับกุญแจที่เคาน์เตอร์บริการยืมคืน</b
                    >
                  </p>
                  <b
                    v-if="std.trans_status === 'borrowed'"
                    style="
                      padding: 7px;
                      background-color: green;
                      border-radius: 30px;
                      color: white;
                      font-size: 12px;
                    "
                    >กำลังใช้งาน</b
                  >

                  <b
                  v-if="std.trans_status === 'approved'"
                  style="
                    padding: 7px;
                    background-color: green;
                    border-radius: 30px;
                    color: white;
                    font-size: 12px;
                  "
                  >กำลังใช้งาน</b
                >
                  <hr class="ml-6" />
                  <p  v-if="
                        std.trans_status === 'inlocker' &&
                        std.locker_number !== ''
                      " 
                      style="font-size: 10px;" class="text-left">หมายเหตุ: กรุณารับกุญแจภายใน 1 ชั่วโมง หากเกินเวลาที่กำหนด เจ้าหน้าที่จะทำการยกเลิกการจองห้อง</p>
                  
                </span>
              </div>
            </div>
            <!-- ======================================= Modal detail meeting room==================================== -->
            <b-modal
              id="modal-cancel-room"
              size="sm"
              headerClass="p-0 border-bottom-0"
              footerClass="p-0 border-top-0"
              centered
              hide-header
              class="modal-cancel-roomm"
            >
              <h6 class="my-4">กรุณากด <b>ยืนยัน</b> เพื่อยกเลิกการจองห้อง</h6>
              <template #modal-title>
                <h5 class="m-1"><b>ยกเลิกการจอง</b></h5>
              </template>

              <template #modal-footer="{ ok, cancel }">
                <b-form @submit.prevent="cancelRoom('ยกเลิกการจองห้อง')">
                  <b-button
                    size=""
                    class="b-between block"
                    variant="success"
                    data-dismiss="modal"
                    type="submit"
                    pill
                    @click="ok()"
                  >
                    ยืนยัน
                  </b-button>

                  <b-button
                    size=""
                    class="b-between"
                    variant="secondary"
                    pill
                    @click="cancel()"
                  >
                    เอาไว้ก่อน
                  </b-button>
                </b-form>
              </template>
            </b-modal>

            <!-- ======================================= END ========================================================= -->

            <!-- ========================================= END ========================================================= -->
          </div>
        </div>

        <!-- ====================================== END ===================================================== -->
        <!-- ====================================== TABS MENU =============================================== -->
        <br />
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div class="segmented-control">
              <input
                type="radio"
                name="radio2"
                v-model="radio_btn"
                @change="onChange"
                value=""
                id="tab-1"
                checked
              />
              <label for="tab-1" class="segmented-control__1">
                <p>ห้องกลุ่มย่อย</p></label
              >
              <input
                type="radio"
                name="radio2"
                v-model="radio_btn"
                @change="onChange"
                value="studio"
                id="tab-2"
              />
              <label for="tab-2" class="segmented-control__2">
                <p>ห้องสตูดิโอ</p>
              </label>

              <input
                type="radio"
                name="radio2"
                v-model="radio_btn"
                @change="onChange"
                value="racord"
                id="tab-3"
              />
              <label for="tab-3" class="segmented-control__3">
                <p>ห้องบันทึกเสียง</p>
              </label>

              <div class="segmented-control__color"></div>
            </div>
          </div>
          <div class="col-lg-6col-md-6 col-sm-6 col-xs-12">
            <!-- <div
              v-for="(std, inx) in history"
              :key="inx"
              class="card card-order-list calendar-border card-status-booking pull-right"
            >
              <span
                v-if="
                  std.room_id === 1 ||
                  std.room_id === 2 ||
                  std.room_id === 3 ||
                  std.room_id === 4 ||
                  std.room_id === 5 ||
                  std.room_id === 6 ||
                  std.room_id === 7
                "
              >
                <div class="chip">
                  <div class="chip__icon">
                    <i
                      v-if="std.trans_status === 'borrowed'"
                      class="fa-solid fa-toggle-on"
                    ></i>

                    <img
                      src="../../assets/icons/inprogress.gif"
                      alt=""
                      width="30"
                      height="30"
                      v-if="std.trans_status === 'booked'"
                    />
                  </div>

                  <p
                    class="text-secondary"
                    v-if="std.trans_status === 'booked'"
                  >
                    <b> รอยืนยัน</b>
                  </p>

                  <p
                    class="text-info"
                    v-if="
                      std.trans_status === 'inlocker' &&
                      std.locker_number !== ''
                    "
                  >
                    <b>รับกุญแจที่ล็อกเกอร์ {{ std.locker_number }}</b>
                  </p>

                  <p
                    class="text-success"
                    v-if="std.trans_status === 'borrowed'"
                  >
                    <b>กำลังใช้งาน</b>
                  </p>
                
                </div>
              </span>
            </div> -->
          </div>
        </div>

        <!-- ===================================== END TABS MENU ============================================ -->
        <br />
        <!-- ===================================== Meeting Room ============================================= -->
        <div class="detail" v-if="radio_btn === ''">
          <div class="card-columns">
            <div
              class="card-room"
              v-for="(item, index) in status_room"
              :key="index"
            >
              <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ MAIN +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
              <!-- ================================================ Teacher ==================================== -->

              <span v-if="!isShowstaff">
                <!-- <span v-if="item.room_id == 1 || item.room_id == 2"> -->

                <div class="card-input">
                  <!-- v-if="item.status === 0 && item.freetimes.length !== 0" -->
                  <div
                    class="card card-order-list card-margin border-0 card-service"
                    v-if="
                      item.room_id === 1 ||
                      item.room_id === 2 ||
                      item.room_id === 3 ||
                      item.room_id === 4 ||
                      item.room_id === 5 ||
                      item.room_id === 6 ||
                      item.room_id === 7
                    "
                  >
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-2 text-left">
                          <h6>{{ item.room_name }}</h6>

                          <img
                            v-if="item.room_id === 1"
                            src="../../assets/meetingrooms/2A.jpeg"
                            alt=""
                            class="zoom"
                          />

                          <img
                            v-if="item.room_id === 2"
                            src="../../assets/meetingrooms/2B.jpeg"
                            alt=""
                            class="zoom"
                          />
                          <img
                            v-if="item.room_id === 3"
                            src="../../assets/meetingrooms/3A.jpeg"
                            alt=""
                            class="zoom"
                          />
                          <img
                            v-if="item.room_id === 4"
                            src="../../assets/meetingrooms/3B.jpeg"
                            alt=""
                            class="zoom"
                          />
                          <img
                            v-if="item.room_id === 5"
                            src="../../assets/meetingrooms/4A.jpeg"
                            alt=""
                            class="zoom"
                          />
                          <img
                            v-if="item.room_id === 6"
                            src="../../assets/meetingrooms/4B.jpeg"
                            alt=""
                            class="zoom"
                          />
                          <img
                            v-if="item.room_id === 7"
                            src="../../assets/meetingrooms/5C.jpeg"
                            alt=""
                            class="zoom"
                          />

                          <!--  -->
                        </div>

                        <div class="col-md-10 text-left">
                          <br />
                          <span class="text-secondary">
                            **เลือกช่วงเวลาเพื่อจอง
                            <div class="space"></div>
                          </span>
                          <div class="time-column">
                            <span
                              v-if="
                                item.status === 1 ||
                                (item.status === 0 &&
                                  item.freetimes.length === 0)
                              "
                            >
                              <b-button
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                08:30-12:00
                              </b-button>

                              <b-button
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                13:00-16:00
                              </b-button>
                            </span>

                            <span v-for="(prod, j) of item.freetimes" :key="j">
                              <b-button
                                v-if="
                                  item.freetimes.length === 1 &&
                                  item.status === 0 &&
                                  prod.time_begin === '13:00'
                                "
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                08:30-12:00
                              </b-button>

                              <b-button
                                pill
                                v-if="
                                  prod.time_begin !== '08:30' ||
                                  prod.time_end !== '16:30'
                                "
                                variant="outline-pink"
                                v-b-modal="
                                  'modal-meetingAnother' +
                                  item.room_id +
                                  prod.time_id
                                "
                                class="b-between"
                                @click="getUsefor(item.room_id)"
                              >
                                {{ prod.time_begin }}-{{ prod.time_end }}
                              </b-button>
                              <span
                                v-for="(timechkuser, iu) in historyall"
                                :key="iu"
                              >
                                <b-button
                                  pill
                                  v-if="
                                    timechkuser.room_id === item.room_id &&
                                    timechkuser.time_begin === '13:00' &&
                                    timechkuser.time_begin !==
                                      prod.time_begin &&
                                    item.freetimes.length === 1
                                  "
                                  variant="outline-secondary"
                                  disabled
                                  class="b-between"
                                >
                                  13:00-16:30
                                </b-button>
                              </span>

                              <b-modal
                                :hide-footer="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingAnother' +
                                  item.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="chkbookingroom"
                              >
                                <template #modal-title>
                                  <div
                                    class="card card-order-list card-margin shadow border-light"
                                  >
                                    <div class="card-body">
                                      <i class="fa-solid fa-bookmark"></i>
                                      ห้อง {{ item.room_name }} เวลาจอง
                                      {{ prod.time_begin }} -
                                      {{ prod.time_end }}
                                    </div>
                                  </div>
                                </template>

                                <div
                                  class="card card-order-list card-margin shadow border-light"
                                >
                                  <div class="card-body">
                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        bookingAnother(
                                          item.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meetingAnother' +
                                            item.room_id +
                                            prod.time_id
                                        )
                                      "
                                    >
                                      <p style="color: blue">
                                        *หมายเหตุ :
                                        กรุณาเลือกวัตุประสงค์การใช้งาน
                                      </p>

                                      <b-form-select
                                        v-model="selected"
                                        :options="options"
                                        class="mb-3"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                            >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                          >
                                        </template>
                                      </b-form-select>
                                      <span
                                        style="color: red; font-weight: bold"
                                        v-if="error != '' || error === null"
                                      >
                                        ERROR : {{ error }}
                                        <br />
                                        <br />
                                      </span>
                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        v-model="input_another"
                                        v-if="
                                          selected === 7 ||
                                          selected === 13 ||
                                          selected === 16
                                        "
                                      />
                                      <!-- :disabled="!isComplete" -->
                                      <button
                                        :disabled="!isCompleteTeach"
                                        type="submit"
                                        class="btn btn-orange deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </button>
                                    </form>
                                  </div>
                                </div>
                              </b-modal>

                              <b-modal
                                :hide-footer="true"
                                :hide-header="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingAnother' +
                                  item.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="!chkbookingroom"
                              >
                                <div
                                  class="card-body justify-content-center card-block p-3 text-center text-danger"
                                >
                                  <h5>
                                    <i
                                      class="fa-solid fa-circle-exclamation"
                                    ></i>
                                    {{ msgbookingroom }}
                                  </h5>
                                </div>
                              </b-modal>
                            </span>
                          </div>

                          <br />
                          <span
                            style="color: gray"
                            v-if="
                              item.room_id === 1 ||
                              item.room_id === 2 ||
                              item.room_id === 3 ||
                              item.room_id === 4 ||
                              item.room_id === 5 ||
                              item.room_id === 6
                            "
                          >
                            <!-- &nbsp;
                                    อุปกรณ์ : รีโมทแอร์ รีโมทจอมอนิเตอร์
                                    แปรงลบกระดาน ปากกาไวท์บอร์ด -->
                            <b-button
                              pill
                              variant="outline-primary"
                              class="b-between"
                              v-if="!showAcc[index]"
                              @click="showAccessoriesMore(index)"
                              size="sm"
                            >
                              อุปกรณ์
                            </b-button>
                            <b-button
                              pill
                              variant="outline-danger"
                              class="b-between"
                              v-if="showAcc[index]"
                              @click="showAccessoriesLess(index)"
                              size="sm"
                            >
                              ปิด
                            </b-button>
                            <br />
                          </span>
                          <span style="color: gray" v-if="item.room_id === 7">
                            <!-- อุปกรณ์ -->
                            <b-button
                              pill
                              variant="outline-primary"
                              class="b-between"
                              v-if="!showAcc[index]"
                              @click="showAccessoriesMore(index)"
                              size="sm"
                            >
                              อุปกรณ์
                            </b-button>
                            <b-button
                              pill
                              variant="outline-danger"
                              class="b-between"
                              v-if="showAcc[index]"
                              @click="showAccessoriesLess(index)"
                              size="sm"
                            >
                              ปิด
                            </b-button>
                            <br />

                            <!-- End -->
                          </span>
                        </div>
                      </div>
                      <!-- 2A -->
                      <span style="color: gray" v-if="item.room_id === 1">
                        <!-- &nbsp;อุปกรณ์ : รีโมทแอร์ รีโมทจอมอนิเตอร์
                                  แปรงลบกระดาน ปากกาไวท์บอร์ด -->
                        <br />
                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                            <!-- 2 -->

                            <!-- 3 -->

                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-wb.png"
                                      alt=""
                                      width="36"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ปากกาไวท์บอร์ด </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!--  -->
                            <!-- 5 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>&nbsp;&nbsp; HDMI </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/meetingrooms/tv.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> จอมอนิเตอร์ </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->

                            <!-- end -->
                          </div>
                        </span>
                      </span>
                      <!-- END -->
                      <!-- 2B -->

                      <span style="color: gray" v-if="item.room_id === 2">
                        <!-- &nbsp;อุปกรณ์ : -->
                        <!-- อุปกรณ์ -->

                        <br />

                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                            <!-- 2 -->

                            <!-- 3 -->

                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-wb.png"
                                      alt=""
                                      width="36"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ปากกาไวท์บอร์ด </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!--  -->
                            <!-- 5 -->

                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/meetingrooms/tv.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> จอมอนิเตอร์ </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->

                            <!-- end -->
                          </div>
                        </span>
                        <!-- End -->
                      </span>

                      <!-- END -->

                      <!-- 3A -->
                      <span style="color: gray" v-if="item.room_id === 3">
                        <!-- &nbsp;อุปกรณ์ : -->
                        <!-- อุปกรณ์ -->

                        <br />

                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                            <!-- 2 -->

                            <!-- 3 -->

                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-wb.png"
                                      alt=""
                                      width="36"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ปากกาไวท์บอร์ด </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!--  -->
                            <!-- 5 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>&nbsp;&nbsp; HDMI </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/meetingrooms/tv.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> จอมอนิเตอร์ </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->

                            <!-- end -->
                          </div>
                        </span>
                        <!-- End -->
                      </span>

                      <!-- END -->

                      <!-- 3B -->
                      <span style="color: gray" v-if="item.room_id === 4">
                        <!-- &nbsp;อุปกรณ์ : -->
                        <!-- อุปกรณ์ -->

                        <br />

                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                            <!-- 2 -->

                            <!-- 3 -->

                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-wb.png"
                                      alt=""
                                      width="36"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ปากกาไวท์บอร์ด </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!--  -->
                            <!-- 5 -->
                            <!-- <div
                                        class="card card-order-list card-margin border-light shadow"
                                      >
                                        <div class="card-body text-left">
                                          <b-row>
                                            <b-col cols="2">
                                              <img
                                                src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                                alt=""
                                                width="40"
                                                height="auto"
                                              />
                                            </b-col>
                                            <b-col cols="10">
                                              <span>
                                                HDMI 
                                              </span>
  
                                              <br />
                                            </b-col>
                                          </b-row>
                                        </div>
                                      </div> -->
                            <!-- end -->
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/meetingrooms/tv.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> จอมอนิเตอร์ </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->

                            <!-- end -->
                            <!-- 8 -->

                            <!-- end -->
                          </div>
                        </span>
                        <!-- End -->
                      </span>

                      <!-- END -->

                      <!-- 4A -->
                      <span style="color: gray" v-if="item.room_id === 5">
                        <!-- &nbsp;อุปกรณ์ : -->
                        <!-- อุปกรณ์ -->

                        <br />

                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                            <!-- 2 -->

                            <!-- 3 -->

                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-wb.png"
                                      alt=""
                                      width="36"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ปากกาไวท์บอร์ด </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!--  -->
                            <!-- 5 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;HDMI </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/meetingrooms/tv.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> จอมอนิเตอร์ </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->

                            <!-- end -->
                          </div>
                        </span>
                        <!-- End -->
                      </span>

                      <!-- END -->

                      <!-- 4B -->
                      <span style="color: gray" v-if="item.room_id === 6">
                        <!-- &nbsp;อุปกรณ์ : -->
                        <!-- อุปกรณ์ -->

                        <br />

                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                            <!-- 2 -->

                            <!-- 3 -->

                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-wb.png"
                                      alt=""
                                      width="36"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ปากกาไวท์บอร์ด </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!--  -->
                            <!-- 5 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;HDMI </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;ไวท์บอร์ด [whiteboard]
                                    </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/meetingrooms/tv.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> จอมอนิเตอร์ </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->

                            <!-- end -->
                          </div>
                        </span>
                        <!-- End -->
                      </span>

                      <!-- END -->

                      <!-- 5A -->

                      <span style="color: gray" v-if="item.room_id === 7">
                        <!-- &nbsp;อุปกรณ์ : -->
                        <!-- อุปกรณ์ -->

                        <br />

                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 2 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-pro.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> โปรเจคเตอร์ [projector] </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 3 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-mic.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp; ไมค์โครโฟน [microphone]
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                          </div>
                        </span>
                        <!-- End -->
                      </span>
                      <!-- END -->
                    </div>
                    <!-- <hr /> -->
                  </div>
                </div>
                <!-- </span> -->
              </span>
              <!-- ================================================ End Teacher ================================ -->

              <!-- ================================================ Student  ====================================-->
              <span v-if="isShowstaff">
                <div class="card-input">
                  <div
                    class="card card-order-list card-margin border-0 card-service"
                    v-if="
                      item.room_id === 1 ||
                      item.room_id === 2 ||
                      item.room_id === 3 ||
                      item.room_id === 4 ||
                      item.room_id === 5 ||
                      item.room_id === 6 ||
                      item.room_id === 7
                    "
                  >
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-2 col-md-2 col-xs-4 text-left">
                          <h6>{{ item.room_name }}</h6>

                          <!-- meeting -->
                          <img
                            v-if="item.room_id === 1"
                            src="../../assets/meetingrooms/2A.jpeg"
                            alt=""
                            class="zoom"
                          />

                          <img
                            v-if="item.room_id === 2"
                            src="../../assets/meetingrooms/2B.jpeg"
                            alt=""
                            class="zoom"
                          />
                          <img
                            v-if="item.room_id === 3"
                            src="../../assets/meetingrooms/3A.jpeg"
                            alt=""
                            class="zoom"
                          />
                          <img
                            v-if="item.room_id === 4"
                            src="../../assets/meetingrooms/3B.jpeg"
                            alt=""
                            class="zoom"
                          />
                          <img
                            v-if="item.room_id === 5"
                            src="../../assets/meetingrooms/4A.jpeg"
                            alt=""
                            class="zoom"
                          />
                          <img
                            v-if="item.room_id === 6"
                            src="../../assets/meetingrooms/4B.jpeg"
                            alt=""
                            class="zoom"
                          />
                          <img
                            v-if="item.room_id === 7"
                            src="../../assets/meetingrooms/5C.jpeg"
                            alt=""
                            class="zoom"
                          />
                          <!-- end -->
                        </div>

                        <div class="col-md-10 col-md-10 col-xs-8 text-left">
                          <br />
                          <span class="text-secondary">
                            **เลือกช่วงเวลาเพื่อจอง
                            <div class="space"></div>
                          </span>
                          <div class="time-column">
                            <span
                              v-if="
                                item.status === 1 ||
                                (item.status === 0 &&
                                  item.freetimes.length === 0)
                              "
                            >
                              <b-button
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                08:30-12:00
                              </b-button>

                              <b-button
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                13:00-16:00
                              </b-button>
                            </span>
                            <span v-for="(prod, j) of item.freetimes" :key="j">
                              <span v-if="!user">
                                <b-button
                                  v-if="
                                    item.freetimes.length === 1 &&
                                    item.status === 0 &&
                                    prod.time_begin === '13:00'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="b-between"
                                >
                                  08:30-12:00
                                </b-button>
                                <b-button
                                  v-if="
                                    item.freetimes.length === 1 &&
                                    item.status === 0 &&
                                    prod.time_begin === '16:30'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="b-between"
                                >
                                  13:00-16:30
                                </b-button>

                                <b-button
                                  pill
                                  v-if="
                                    prod.time_begin !== '08:30' ||
                                    prod.time_end !== '16:30'
                                  "
                                  variant="outline-pink"
                                  v-b-modal="
                                    'modal-meetingMain' +
                                    item.room_id +
                                    prod.time_id
                                  "
                                  class="b-between"
                                  @click="getUsefor(item.room_id)"
                                >
                                  {{ prod.time_begin }}-{{ prod.time_end }}
                                </b-button>

                                <span
                                  v-for="(timechkuse, iue) in historyall"
                                  :key="iue"
                                >
                                  <b-button
                                    pill
                                    v-if="
                                      timechkuse.room_id === item.room_id &&
                                      timechkuse.time_begin === '13:00' &&
                                      timechkuse.time_begin !==
                                        prod.time_begin &&
                                      item.freetimes.length === 1
                                    "
                                    variant="outline-secondary"
                                    disabled
                                    class="b-between"
                                  >
                                    13:00-16:30
                                  </b-button>
                                </span>
                              </span>

                              <!-- if user :login  -->
                              <span v-if="user">
                                <b-button
                                  v-if="
                                    item.freetimes.length === 1 &&
                                    item.status === 0 &&
                                    prod.time_begin === '13:00'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="b-between"
                                >
                                  08:30-12:00
                                </b-button>

                                <b-button
                                  pill
                                  v-if="
                                    prod.time_begin !== '08:30' ||
                                    (prod.time_end !== '16:30' &&
                                      item.freetimes.length !== 0)
                                  "
                                  variant="outline-pink"
                                  class="b-between"
                                  href="/login"
                                >
                                  {{ prod.time_begin }}-{{ prod.time_end }}
                                </b-button>

                                <span
                                  v-for="(timechkuser, iu) in historyall"
                                  :key="iu"
                                >
                                  <b-button
                                    pill
                                    v-if="
                                      timechkuser.room_id === item.room_id &&
                                      timechkuser.time_begin === '13:00' &&
                                      timechkuser.time_begin !==
                                        prod.time_begin &&
                                      item.freetimes.length === 1
                                    "
                                    variant="outline-secondary"
                                    disabled
                                    class="b-between"
                                  >
                                    13:00-16:30
                                  </b-button>
                                </span>
                              </span>

                              <b-modal
                                :hide-footer="true"
                                v-if="chkbookingroom"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingMain' +
                                  item.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                              >
                                <template #modal-title>
                                  <div
                                    class="card card-order-list card-margin shadow-sm border-light card-time-title"
                                  >
                                    <div class="card-body">
                                      <i class="fa-solid fa-bookmark"></i>
                                      ห้อง {{ item.room_name }} เวลาจอง
                                      {{ prod.time_begin }} -
                                      {{ prod.time_end }}
                                    </div>
                                  </div>
                                </template>
                                <div
                                  class="card card-order-list card-margin shadow-sm border-light card-time-body"
                                >
                                  <div class="card-body">
                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        booking(
                                          item.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meetingMain' +
                                            item.room_id +
                                            prod.time_id
                                        )
                                      "
                                      v-if="
                                        (auth.isLibraryStaff === 1 &&
                                          item.floor !== 6) ||
                                        auth.isLibraryStaff !== 1
                                      "
                                    >
                                      <b-form-select
                                        v-model="selected"
                                        :options="options"
                                        class="mb-3 input-style"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                            >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                          >
                                        </template>
                                      </b-form-select>
                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        v-model="input_another"
                                        v-if="
                                          selected === 7 ||
                                          selected === 13 ||
                                          selected === 16
                                        "
                                      />
                                      <p style="color: red">
                                        **หมายเหตุ : กรอกรหัสนักศึกษา
                                        {{ item.min_person }} คนขึ้นไป
                                      </p>
                                      <span
                                        style="color: red"
                                        v-if="error != '' || error === null"
                                      >
                                        **{{ error }}
                                      </span>
                                      <!-- <div class="space"></div> -->

                                      <b-row>
                                        <b-col
                                          cols="6"
                                          v-for="(stdr, index) in input_stdcode"
                                          :key="index"
                                        >
                                          <input
                                            class="form-control input-style"
                                            placeholder="กรอกรหัสนักศึกษา"
                                            maxlength="11"
                                            v-model="values[index]"
                                          />
                                        </b-col>
                                      </b-row>

                                      <button
                                        :disabled="!isComplete"
                                        type="submit"
                                        class="btn btn-orange deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </button>
                                    </form>

                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        bookingAnother(
                                          item.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meetingMain' +
                                            item.room_id +
                                            prod.time_id
                                        )
                                      "
                                      v-if="
                                        auth.isLibraryStaff === 1 &&
                                        item.floor === 6
                                      "
                                    >
                                      <!-- Teacher -->
                                      <span>
                                        <b-button variant="outline-primary">
                                          สำหรับอาจารย์
                                        </b-button>
                                      </span>
                                      <span
                                        style="color: red; font-weight: bold"
                                        v-if="error != '' || error === null"
                                      >
                                        ERROR : {{ error }}
                                        <br />
                                        <br />
                                      </span>
                                      <b-row>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="เบอร์โทรศัพท์"
                                            maxlength="10"
                                            v-model="input_room_Teacher_phone"
                                          />
                                        </b-col>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="ชื่อ - นามสกุล"
                                            v-model="input_room_Teacher_name"
                                            autocomplete
                                          />
                                        </b-col>
                                        <!-- this.optionsfac -->
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selectedfac"
                                            :options="optionsfac"
                                            class="mb-3 input-style"
                                            value-field="fac_code"
                                            text-field="fac_name"
                                            disabled-field="notEnabled"
                                            @change="get_branch()"
                                          >
                                            <!-- Teacher -->

                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                                >เลือกคณะ</b-form-select-option
                                              >
                                            </template>
                                          </b-form-select>
                                        </b-col>
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selectedbranch"
                                            :options="optionsbranch"
                                            class="mb-3 input-style"
                                            value-field="branch_code"
                                            text-field="branch_name"
                                            disabled-field="notEnabled"
                                          >
                                            <!-- Teacher -->

                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                                >เลือกสาขา</b-form-select-option
                                              >
                                            </template>
                                          </b-form-select>
                                        </b-col>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="อีเมล"
                                            maxlength=""
                                            v-model="input_room_Teacher_email"
                                            type="email"
                                          />
                                        </b-col>
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selected"
                                            :options="options"
                                            class="mb-3 input-style"
                                            value-field="usefor_id"
                                            text-field="usefor_name"
                                            disabled-field="notEnabled"
                                          >
                                            <!-- Teacher -->

                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                                >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                              >
                                            </template>
                                          </b-form-select>
                                          <input
                                            type="text"
                                            class="form-control input-style"
                                            placeholder="กรอกวัตถุประสงค์"
                                            v-model="input_another"
                                            v-if="
                                              selected === 7 ||
                                              selected === 13 ||
                                              selected === 16
                                            "
                                          />
                                        </b-col>
                                      </b-row>

                                      <!-- :disabled="!isComplete" -->
                                      <button
                                        v-if="
                                          auth.isLibraryStaff === 1 &&
                                          item.floor === 6
                                        "
                                        :disabled="!isCompleteAnothor"
                                        type="submit"
                                        class="btn btn-orange deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </button>
                                    </form>
                                  </div>
                                </div>
                              </b-modal>

                              <b-modal
                                :hide-footer="true"
                                :hide-header="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingMain' +
                                  item.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="!chkbookingroom"
                              >
                                <div
                                  class="card-body justify-content-center card-block p-3 text-center text-danger"
                                >
                                  <h5>
                                    <i
                                      class="fa-solid fa-circle-exclamation"
                                    ></i>
                                    {{ msgbookingroom }}
                                  </h5>
                                </div>
                              </b-modal>
                            </span>
                          </div>
                          <br />

                          <span style="color: gray">
                            <b-button
                              pill
                              variant="outline-primary"
                              class="b-between"
                              v-if="!showAcc[index]"
                              @click="showAccessoriesMore(index)"
                              size="sm"
                            >
                              อุปกรณ์
                            </b-button>
                            <b-button
                              pill
                              variant="outline-danger"
                              class="b-between"
                              v-if="showAcc[index]"
                              @click="showAccessoriesLess(index)"
                              size="sm"
                            >
                              ปิด
                            </b-button>
                            <br />

                            <!-- End -->
                          </span>
                        </div>
                      </div>
                      <!-- 2A -->
                      <span style="color: gray" v-if="item.room_id === 1">
                        <!-- &nbsp;อุปกรณ์ : รีโมทแอร์ รีโมทจอมอนิเตอร์
                                  แปรงลบกระดาน ปากกาไวท์บอร์ด -->
                        <br />
                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                            <!-- 2 -->

                            <!-- 3 -->

                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-wb.png"
                                      alt=""
                                      width="36"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ปากกาไวท์บอร์ด </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!--  -->
                            <!-- 5 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;HDMI </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/meetingrooms/tv.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> จอมอนิเตอร์ </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->

                            <!-- end -->
                          </div>
                        </span>
                      </span>
                      <!-- END -->
                      <!-- 2B -->

                      <span style="color: gray" v-if="item.room_id === 2">
                        <!-- &nbsp;อุปกรณ์ : -->
                        <!-- อุปกรณ์ -->

                        <br />

                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-wb.png"
                                      alt=""
                                      width="36"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ปากกาไวท์บอร์ด </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>

                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/meetingrooms/tv.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> จอมอนิเตอร์ </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->

                            <!-- end -->
                          </div>
                        </span>
                        <!-- End -->
                      </span>

                      <!-- END -->

                      <!-- 3A -->
                      <span style="color: gray" v-if="item.room_id === 3">
                        <!-- &nbsp;อุปกรณ์ : -->
                        <!-- อุปกรณ์ -->

                        <br />

                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                            <!-- 2 -->

                            <!-- 3 -->

                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-wb.png"
                                      alt=""
                                      width="36"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ปากกาไวท์บอร์ด </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!--  -->
                            <!-- 5 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>&nbsp;&nbsp;HDMI </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/meetingrooms/tv.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> จอมอนิเตอร์ </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->

                            <!-- end -->
                          </div>
                        </span>
                        <!-- End -->
                      </span>

                      <!-- END -->

                      <!-- 3B -->
                      <span style="color: gray" v-if="item.room_id === 4">
                        <!-- &nbsp;อุปกรณ์ : -->
                        <!-- อุปกรณ์ -->

                        <br />

                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                            <!-- 2 -->

                            <!-- 3 -->

                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-wb.png"
                                      alt=""
                                      width="36"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ปากกาไวท์บอร์ด </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>

                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/meetingrooms/tv.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> จอมอนิเตอร์ </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->

                            <!-- end -->
                            <!-- 8 -->

                            <!-- end -->
                          </div>
                        </span>
                        <!-- End -->
                      </span>

                      <!-- END -->

                      <!-- 4A -->
                      <span style="color: gray" v-if="item.room_id === 5">
                        <!-- &nbsp;อุปกรณ์ : -->
                        <!-- อุปกรณ์ -->

                        <br />

                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                            <!-- 2 -->

                            <!-- 3 -->

                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-wb.png"
                                      alt=""
                                      width="36"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ปากกาไวท์บอร์ด </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!--  -->
                            <!-- 5 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;HDMI </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/meetingrooms/tv.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> จอมอนิเตอร์ </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->

                            <!-- end -->
                          </div>
                        </span>
                        <!-- End -->
                      </span>

                      <!-- END -->

                      <!-- 4B -->
                      <span style="color: gray" v-if="item.room_id === 6">
                        <!-- &nbsp;อุปกรณ์ : -->
                        <!-- อุปกรณ์ -->

                        <br />

                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                            <!-- 2 -->

                            <!-- 3 -->

                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-wb.png"
                                      alt=""
                                      width="36"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ปากกาไวท์บอร์ด </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!--  -->
                            <!-- 5 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;HDMI </span>

                                    <br />
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="../../assets/meetingrooms/tv.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> จอมอนิเตอร์ </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- 7 -->

                            <!-- end -->
                          </div>
                        </span>
                        <!-- End -->
                      </span>

                      <!-- END -->

                      <!-- 5A -->

                      <span style="color: gray" v-if="item.room_id === 7">
                        <br />
                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-bwb.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> ไวท์บอร์ด [whiteboard] </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 2 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-pro.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> โปรเจคเตอร์ [projector] </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 3 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/img/acc-mic.png"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp; ไมค์โครโฟน [microphone]
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                          </div>
                        </span>
                        <!-- End -->
                      </span>
                      <!-- END -->
                    </div>
                    <!-- <hr /> -->
                    <!-- v-if="item.status === 0" -->
                  </div>

                  <div></div>
                </div>
              </span>
              <!-- ================================================ End student ================================ -->
              <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ END MAIN ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
            </div>
          </div>
        </div>
        <!-- ==================================== END Meeting Room ========================================= -->
        <!-- ==================================== STUDIO =================================================== -->
        <div class="detail" v-if="radio_btn === 'studio'">
          <br />
          <div class="card-columns">
            <div
              class="card-room"
              v-for="(item, index) in status_room"
              :key="index"
            >
              <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ MAIN ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
              <!-- ================================================ Teacher ==================================== -->
              <span v-if="!isShowstaff">
                <!-- <span v-if="item.room_id == 1 || item.room_id == 2"> -->
                <div class="card-input">
                  <!-- v-if="item.status === 0 && item.freetimes.length !== 0" -->
                  <div
                    class="card card-order-list card-margin border-0 card-service"
                    v-if="item.room_id === 8 || item.room_id === 9"
                  >
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-2 text-left">
                          <h6>{{ item.room_name }}</h6>
                          <img
                            v-if="item.room_id === 8"
                            src="../../assets/meetingrooms/stu1.jpeg"
                            alt=""
                            class="zoom"
                          />
                          <img
                            v-if="item.room_id === 9"
                            src="../../assets/meetingrooms/stu2.jpeg"
                            alt=""
                            class="zoom"
                          />
                        </div>

                        <div class="col-md-10 text-left">
                          <br />
                          <span class="text-secondary">
                            **เลือกช่วงเวลาเพื่อจอง
                            <div class="space"></div>
                          </span>
                          <div class="time-column">
                            <span
                              v-if="
                                item.status === 1 ||
                                (item.status === 0 &&
                                  item.freetimes.length === 0)
                              "
                            >
                              <b-button
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                08:30-12:00
                              </b-button>

                              <b-button
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                13:00-16:00
                              </b-button>
                            </span>

                            <span v-for="(prod, j) of item.freetimes" :key="j">
                              <b-button
                                v-if="
                                  item.freetimes.length === 1 &&
                                  item.status === 0 &&
                                  prod.time_begin === '13:00'
                                "
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                08:30-12:00
                              </b-button>

                              <b-button
                                pill
                                v-if="
                                  prod.time_begin !== '08:30' ||
                                  prod.time_end !== '16:30'
                                "
                                variant="outline-pink"
                                v-b-modal="
                                  'modal-meetingAnother' +
                                  item.room_id +
                                  prod.time_id
                                "
                                class="b-between"
                                @click="getUsefor(item.room_id)"
                              >
                                {{ prod.time_begin }}-{{ prod.time_end }}
                              </b-button>
                              <span
                                v-for="(timechkuser, iu) in historyall"
                                :key="iu"
                              >
                                <b-button
                                  pill
                                  v-if="
                                    timechkuser.room_id === item.room_id &&
                                    timechkuser.time_begin === '13:00' &&
                                    timechkuser.time_begin !==
                                      prod.time_begin &&
                                    item.freetimes.length === 1
                                  "
                                  variant="outline-secondary"
                                  disabled
                                  class="b-between"
                                >
                                  13:00-16:30
                                </b-button>
                              </span>

                              <b-modal
                                :hide-footer="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingAnother' +
                                  item.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="chkbookingroom"
                              >
                                <template #modal-title>
                                  <div
                                    class="card card-order-list card-margin shadow border-light"
                                  >
                                    <div class="card-body">
                                      <i class="fa-solid fa-bookmark"></i>
                                      ห้อง {{ item.room_name }} เวลาจอง
                                      {{ prod.time_begin }} -
                                      {{ prod.time_end }}
                                    </div>
                                  </div>
                                </template>

                                <div
                                  class="card card-order-list card-margin shadow border-light"
                                >
                                  <div class="card-body">
                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        bookingAnother(
                                          item.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meetingAnother' +
                                            item.room_id +
                                            prod.time_id
                                        )
                                      "
                                    >
                                      <p style="color: blue">
                                        *หมายเหตุ :
                                        กรุณาเลือกวัตุประสงค์การใช้งาน
                                      </p>

                                      <b-form-select
                                        v-model="selected"
                                        :options="options"
                                        class="mb-3"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                            >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                          >
                                        </template>
                                      </b-form-select>
                                      <span
                                        style="color: red; font-weight: bold"
                                        v-if="error != '' || error === null"
                                      >
                                        ERROR : {{ error }}
                                        <br />
                                        <br />
                                      </span>
                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        v-model="input_another"
                                        v-if="
                                          selected === 7 ||
                                          selected === 13 ||
                                          selected === 16
                                        "
                                      />

                                      <!-- :disabled="!isComplete" -->
                                      <button
                                        :disabled="!isCompleteTeach"
                                        type="submit"
                                        class="btn btn-orange deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </button>
                                    </form>
                                  </div>
                                </div>
                              </b-modal>

                              <b-modal
                                :hide-footer="true"
                                :hide-header="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingAnother' +
                                  item.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="!chkbookingroom"
                              >
                                <div
                                  class="card-body justify-content-center card-block p-3 text-center text-danger"
                                >
                                  <h5>
                                    <i
                                      class="fa-solid fa-circle-exclamation"
                                    ></i>
                                    {{ msgbookingroom }}
                                  </h5>
                                </div>
                              </b-modal>
                            </span>
                          </div>

                          <br />

                          <span style="color: gray" v-if="item.room_id === 8">
                            <b-button
                              pill
                              variant="outline-primary"
                              class="b-between"
                              v-if="!showAcc[index]"
                              @click="showAccessoriesMore(index)"
                              size="sm"
                            >
                              อุปกรณ์
                            </b-button>
                            <b-button
                              pill
                              variant="outline-danger"
                              class="b-between"
                              v-if="showAcc[index]"
                              @click="showAccessoriesLess(index)"
                              size="sm"
                            >
                              ปิด
                            </b-button>
                            <br />
                          </span>

                          <span style="color: gray" v-if="item.room_id === 9">
                            <b-button
                              pill
                              variant="outline-primary"
                              class="b-between"
                              v-if="!showAcc[index]"
                              @click="showAccessoriesMore(index)"
                              size="sm"
                            >
                              อุปกรณ์
                            </b-button>
                            <b-button
                              pill
                              variant="outline-danger"
                              class="b-between"
                              v-if="showAcc[index]"
                              @click="showAccessoriesLess(index)"
                              size="sm"
                            >
                              ปิด
                            </b-button>
                            <br />
                          </span>
                        </div>
                      </div>

                      <span style="color: gray" v-if="item.room_id === 8">
                        <br />
                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/comstu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 2 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/moniterstu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;จอแสดงผล </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 3 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/camerastu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;กล้องบันทึกภาพวิดีโอ
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/saramonic.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;ไมค์ไร้สาย saramonic
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 5 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/switcherstu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;เครื่อง Switcher ภาพ
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/mixerstu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;เครื่องมิกซ์เสียง </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                          </div>
                        </span>
                      </span>

                      <span style="color: gray" v-if="item.room_id === 9">
                        <br />
                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/comstu2.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 2 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/imac.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp; IMAC </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 3 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/moniterstu2.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;จอแสดงผล </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/camerastu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;กล้องบันทึกภาพวิดีโอ
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 5 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/camerastu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp; ไมค์ไร้สาย saramonic
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/mixerstu2.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp; เครื่องมิกซ์เสียง
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/camerastu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp; เครื่อง Switcher </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 8 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/viesonicpc.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp; เครื่อง Viesonic pc
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                          </div>
                        </span>
                      </span>
                    </div>
                    <!-- <hr /> -->
                  </div>
                </div>
                <!-- </span> -->
              </span>
              <!-- ================================================ End Teacher ================================ -->

              <!-- ================================================ Student  ====================================-->
              <span v-if="isShowstaff">
                <div class="card-input">
                  <div
                    class="card card-order-list card-margin border-0 card-service"
                    v-if="item.room_id === 8 || item.room_id === 9"
                  >
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-2 text-left">
                          <h6>{{ item.room_name }}</h6>

                          <img
                            v-if="item.room_id === 8"
                            src="../../assets/meetingrooms/stu1.jpeg"
                            alt=""
                            class="zoom"
                          />

                          <img
                            v-if="item.room_id === 9"
                            src="../../assets/meetingrooms/stu2.jpeg"
                            alt=""
                            class="zoom"
                          />
                        </div>

                        <div class="col-md-10 text-left">
                          <br />
                          <span class="text-secondary">
                            **เลือกช่วงเวลาเพื่อจอง
                            <div class="space"></div>
                          </span>
                          <div class="time-column">
                            <span
                              v-if="
                                item.status === 1 ||
                                (item.status === 0 &&
                                  item.freetimes.length === 0)
                              "
                            >
                              <b-button
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                08:30-12:00
                              </b-button>

                              <b-button
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                13:00-16:00
                              </b-button>
                            </span>
                            <span v-for="(prod, j) of item.freetimes" :key="j">
                              <span v-if="!user">
                                <b-button
                                  v-if="
                                    item.freetimes.length === 1 &&
                                    item.status === 0 &&
                                    prod.time_begin === '13:00'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="b-between"
                                >
                                  08:30-12:00
                                </b-button>
                                <b-button
                                  v-if="
                                    item.freetimes.length === 1 &&
                                    item.status === 0 &&
                                    prod.time_begin === '16:30'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="b-between"
                                >
                                  13:00-16:30
                                </b-button>

                                <b-button
                                  pill
                                  v-if="
                                    prod.time_begin !== '08:30' ||
                                    prod.time_end !== '16:30'
                                  "
                                  variant="outline-pink"
                                  v-b-modal="
                                    'modal-meetingMain' +
                                    item.room_id +
                                    prod.time_id
                                  "
                                  class="b-between"
                                  @click="getUsefor(item.room_id)"
                                >
                                  {{ prod.time_begin }}-{{ prod.time_end }}
                                </b-button>

                                <span
                                  v-for="(timechkuse, iue) in historyall"
                                  :key="iue"
                                >
                                  <b-button
                                    pill
                                    v-if="
                                      timechkuse.room_id === item.room_id &&
                                      timechkuse.time_begin === '13:00' &&
                                      timechkuse.time_begin !==
                                        prod.time_begin &&
                                      item.freetimes.length === 1
                                    "
                                    variant="outline-secondary"
                                    disabled
                                    class="b-between"
                                  >
                                    13:00-16:30
                                  </b-button>
                                </span>
                              </span>

                              <!-- if user :login  -->
                              <span v-if="user">
                                <b-button
                                  v-if="
                                    item.freetimes.length === 1 &&
                                    item.status === 0 &&
                                    prod.time_begin === '13:00'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="b-between"
                                >
                                  08:30-12:00
                                </b-button>

                                <b-button
                                  pill
                                  v-if="
                                    prod.time_begin !== '08:30' ||
                                    (prod.time_end !== '16:30' &&
                                      item.freetimes.length !== 0)
                                  "
                                  variant="outline-pink"
                                  class="b-between"
                                  href="/login"
                                >
                                  {{ prod.time_begin }}-{{ prod.time_end }}
                                </b-button>

                                <span
                                  v-for="(timechkuser, iu) in historyall"
                                  :key="iu"
                                >
                                  <b-button
                                    pill
                                    v-if="
                                      timechkuser.room_id === item.room_id &&
                                      timechkuser.time_begin === '13:00' &&
                                      timechkuser.time_begin !==
                                        prod.time_begin &&
                                      item.freetimes.length === 1
                                    "
                                    variant="outline-secondary"
                                    disabled
                                    class="b-between"
                                  >
                                    13:00-16:30
                                  </b-button>
                                </span>
                              </span>

                              <b-modal
                                :hide-footer="true"
                                v-if="chkbookingroom"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingMain' +
                                  item.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                              >
                                <template #modal-title>
                                  <div
                                    class="card card-order-list card-margin shadow-sm border-light card-time-title"
                                  >
                                    <div class="card-body">
                                      <i class="fa-solid fa-bookmark"></i>
                                      ห้อง {{ item.room_name }} เวลาจอง
                                      {{ prod.time_begin }} -
                                      {{ prod.time_end }}
                                    </div>
                                  </div>
                                </template>
                                <div
                                  class="card card-order-list card-margin shadow-sm border-light card-time-body"
                                >
                                  <div class="card-body">
                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        booking(
                                          item.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meetingMain' +
                                            item.room_id +
                                            prod.time_id
                                        )
                                      "
                                      v-if="
                                        (auth.isLibraryStaff === 1 &&
                                          item.floor !== 6) ||
                                        auth.isLibraryStaff !== 1
                                      "
                                    >
                                      <b-form-select
                                        v-model="selected"
                                        :options="options"
                                        class="mb-3 input-style"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                            >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                          >
                                        </template>
                                      </b-form-select>
                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        v-model="input_another"
                                        v-if="
                                          selected === 7 ||
                                          selected === 13 ||
                                          selected === 16
                                        "
                                      />
                                      <p style="color: red">
                                        **หมายเหตุ : กรอกรหัสนักศึกษา
                                        {{ item.min_person }} คนขึ้นไป
                                      </p>
                                      <span
                                        style="color: red"
                                        v-if="error != '' || error === null"
                                      >
                                        **{{ error }}
                                      </span>
                                      <!-- <div class="space"></div> -->

                                      <b-row>
                                        <b-col
                                          cols="6"
                                          v-for="(stdr, index) in input_stdcode"
                                          :key="index"
                                        >
                                          <input
                                            class="form-control input-style"
                                            placeholder="กรอกรหัสนักศึกษา"
                                            maxlength="11"
                                            v-model="values[index]"
                                          />
                                        </b-col>
                                      </b-row>

                                      <button
                                        :disabled="!isComplete"
                                        type="submit"
                                        class="btn btn-orange deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </button>
                                    </form>

                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        bookingAnother(
                                          item.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meetingMain' +
                                            item.room_id +
                                            prod.time_id
                                        )
                                      "
                                      v-if="
                                        auth.isLibraryStaff === 1 &&
                                        item.floor === 6
                                      "
                                    >
                                      <!-- Teacher -->
                                      <span>
                                        <b-button variant="outline-primary">
                                          สำหรับอาจารย์
                                        </b-button>
                                      </span>
                                      <span
                                        style="color: red; font-weight: bold"
                                        v-if="error != '' || error === null"
                                      >
                                        ERROR : {{ error }}
                                        <br />
                                        <br />
                                      </span>
                                      <b-row>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="เบอร์โทรศัพท์"
                                            maxlength="10"
                                            v-model="input_room_Teacher_phone"
                                          />
                                        </b-col>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="ชื่อ - นามสกุล"
                                            v-model="input_room_Teacher_name"
                                            autocomplete
                                          />
                                        </b-col>
                                        <!-- this.optionsfac -->
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selectedfac"
                                            :options="optionsfac"
                                            class="mb-3 input-style"
                                            value-field="fac_code"
                                            text-field="fac_name"
                                            disabled-field="notEnabled"
                                            @change="get_branch()"
                                          >
                                            <!-- Teacher -->

                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                                >เลือกคณะ</b-form-select-option
                                              >
                                            </template>
                                          </b-form-select>
                                        </b-col>
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selectedbranch"
                                            :options="optionsbranch"
                                            class="mb-3 input-style"
                                            value-field="branch_code"
                                            text-field="branch_name"
                                            disabled-field="notEnabled"
                                          >
                                            <!-- Teacher -->

                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                                >เลือกสาขา</b-form-select-option
                                              >
                                            </template>
                                          </b-form-select>
                                        </b-col>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="อีเมล"
                                            maxlength=""
                                            v-model="input_room_Teacher_email"
                                            type="email"
                                          />
                                        </b-col>
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selected"
                                            :options="options"
                                            class="mb-3 input-style"
                                            value-field="usefor_id"
                                            text-field="usefor_name"
                                            disabled-field="notEnabled"
                                          >
                                            <!-- Teacher -->

                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                                >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                              >
                                            </template>
                                          </b-form-select>
                                          <input
                                            type="text"
                                            class="form-control input-style"
                                            placeholder="กรอกวัตถุประสงค์"
                                            v-model="input_another"
                                            v-if="
                                              selected === 7 ||
                                              selected === 13 ||
                                              selected === 16
                                            "
                                          />
                                        </b-col>
                                      </b-row>

                                      <!-- :disabled="!isComplete" -->
                                      <button
                                        v-if="
                                          auth.isLibraryStaff === 1 &&
                                          item.floor === 6
                                        "
                                        :disabled="!isCompleteAnothor"
                                        type="submit"
                                        class="btn btn-orange deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </button>
                                    </form>
                                  </div>
                                </div>
                              </b-modal>

                              <b-modal
                                :hide-footer="true"
                                :hide-header="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingMain' +
                                  item.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="!chkbookingroom"
                              >
                                <div
                                  class="card-body justify-content-center card-block p-3 text-center text-danger"
                                >
                                  <h5>
                                    <i
                                      class="fa-solid fa-circle-exclamation"
                                    ></i>
                                    {{ msgbookingroom }}
                                  </h5>
                                </div>
                              </b-modal>
                            </span>
                          </div>
                          <br />

                          <span style="color: gray">
                            <b-button
                              pill
                              variant="outline-primary"
                              class="b-between"
                              v-if="!showAcc[index]"
                              @click="showAccessoriesMore(index)"
                              size="sm"
                            >
                              อุปกรณ์
                            </b-button>
                            <b-button
                              pill
                              variant="outline-danger"
                              class="b-between"
                              v-if="showAcc[index]"
                              @click="showAccessoriesLess(index)"
                              size="sm"
                            >
                              ปิด
                            </b-button>
                            <br />

                            <!-- End -->
                          </span>
                        </div>
                      </div>

                      <span style="color: gray" v-if="item.room_id === 8">
                        <br />
                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/comstu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 2 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/moniterstu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;จอแสดงผล </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 3 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/camerastu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;กล้องบันทึกภาพวิดีโอ
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/saramonic.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;ไมค์ไร้สาย saramonic
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 5 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/switcherstu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;เครื่อง Switcher ภาพ
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/mixerstu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;เครื่องมิกซ์เสียง </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                          </div>
                        </span>
                      </span>

                      <span style="color: gray" v-if="item.room_id === 9">
                        <br />
                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/comstu2.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 2 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/imac.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp; IMAC </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 3 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/moniterstu2.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;จอแสดงผล </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 4 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/camerastu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;กล้องบันทึกภาพวิดีโอ
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 5 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/camerastu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp; ไมค์ไร้สาย saramonic
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 6 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/mixerstu2.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp; เครื่องมิกซ์เสียง
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 7 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/camerastu1.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp; เครื่อง Switcher </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 8 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/viesonicpc.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp; เครื่อง Viesonic pc
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                          </div>
                        </span>
                      </span>
                    </div>
                    <!-- <hr /> -->
                    <!-- v-if="item.status === 0" -->
                  </div>

                  <div></div>
                </div>
              </span>
              <!-- ================================================ End student ================================ -->
              <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ END MAIN ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
              <!-- ###################################################### 2 Culums #################################################################  -->
              <!-- ######################################################  END  2 Culums ########################################################### -->
            </div>
          </div>
        </div>
        <!-- =================================== END STUDIO ================================================ -->
        <!-- =================================== RACORD ==================================================== -->
        <div class="detail" v-if="radio_btn === 'racord'">
          <br />
          <div class="card-columns">
            <div
              class="card-room"
              v-for="(item, index) in status_room"
              :key="index"
            >
              <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  MAIN ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
              <!-- ================================================ Teacher ==================================== -->
              <span v-if="!isShowstaff">
                <!-- <span v-if="item.room_id == 1 || item.room_id == 2"> -->
                <div class="card-input">
                  <!-- v-if="item.status === 0 && item.freetimes.length !== 0" -->
                  <div
                    class="card card-order-list card-margin border-0 card-service"
                    v-if="item.room_id === 10"
                  >
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-2 text-left">
                          <h6>{{ item.room_name }}</h6>

                          <img
                            v-if="item.room_id === 10"
                            src="../../assets/meetingrooms/rac.jpeg"
                            alt=""
                            class="zoom"
                          />
                        </div>

                        <div class="col-md-10 text-left">
                          <br />
                          <span class="text-secondary">
                            **เลือกช่วงเวลาเพื่อจอง
                            <div class="space"></div>
                          </span>
                          <div class="time-column">
                            <span
                              v-if="
                                item.status === 1 ||
                                (item.status === 0 &&
                                  item.freetimes.length === 0)
                              "
                            >
                              <b-button
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                08:30-12:00
                              </b-button>

                              <b-button
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                13:00-16:00
                              </b-button>
                            </span>

                            <span v-for="(prod, j) of item.freetimes" :key="j">
                              <b-button
                                v-if="
                                  item.freetimes.length === 1 &&
                                  item.status === 0 &&
                                  prod.time_begin === '13:00'
                                "
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                08:30-12:00
                              </b-button>

                              <b-button
                                pill
                                v-if="
                                  prod.time_begin !== '08:30' ||
                                  prod.time_end !== '16:30'
                                "
                                variant="outline-pink"
                                v-b-modal="
                                  'modal-meetingAnother' +
                                  item.room_id +
                                  prod.time_id
                                "
                                class="b-between"
                                @click="getUsefor(item.room_id)"
                              >
                                {{ prod.time_begin }}-{{ prod.time_end }}
                              </b-button>
                              <span
                                v-for="(timechkuser, iu) in historyall"
                                :key="iu"
                              >
                                <b-button
                                  pill
                                  v-if="
                                    timechkuser.room_id === item.room_id &&
                                    timechkuser.time_begin === '13:00' &&
                                    timechkuser.time_begin !==
                                      prod.time_begin &&
                                    item.freetimes.length === 1
                                  "
                                  variant="outline-secondary"
                                  disabled
                                  class="b-between"
                                >
                                  13:00-16:30
                                </b-button>
                              </span>

                              <b-modal
                                :hide-footer="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingAnother' +
                                  item.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="chkbookingroom"
                              >
                                <template #modal-title>
                                  <div
                                    class="card card-order-list card-margin shadow border-light"
                                  >
                                    <div class="card-body">
                                      <i class="fa-solid fa-bookmark"></i>
                                      ห้อง {{ item.room_name }} เวลาจอง
                                      {{ prod.time_begin }} -
                                      {{ prod.time_end }}
                                    </div>
                                  </div>
                                </template>

                                <div
                                  class="card card-order-list card-margin shadow border-light"
                                >
                                  <div class="card-body">
                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        bookingAnother(
                                          item.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meetingAnother' +
                                            item.room_id +
                                            prod.time_id
                                        )
                                      "
                                    >
                                      <p style="color: blue">
                                        *หมายเหตุ :
                                        กรุณาเลือกวัตุประสงค์การใช้งาน
                                      </p>

                                      <b-form-select
                                        v-model="selected"
                                        :options="options"
                                        class="mb-3"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                            >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                          >
                                        </template>
                                      </b-form-select>
                                      <span
                                        style="color: red; font-weight: bold"
                                        v-if="error != '' || error === null"
                                      >
                                        ERROR : {{ error }}
                                        <br />
                                        <br />
                                      </span>
                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        v-model="input_another"
                                        v-if="
                                          selected === 7 ||
                                          selected === 13 ||
                                          selected === 16
                                        "
                                      />

                                      <!-- :disabled="!isComplete" -->
                                      <button
                                        :disabled="!isCompleteTeach"
                                        type="submit"
                                        class="btn btn-orange deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </button>
                                    </form>
                                  </div>
                                </div>
                              </b-modal>

                              <b-modal
                                :hide-footer="true"
                                :hide-header="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingAnother' +
                                  item.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="!chkbookingroom"
                              >
                                <div
                                  class="card-body justify-content-center card-block p-3 text-center text-danger"
                                >
                                  <h5>
                                    <i
                                      class="fa-solid fa-circle-exclamation"
                                    ></i>
                                    {{ msgbookingroom }}
                                  </h5>
                                </div>
                              </b-modal>
                            </span>
                          </div>

                          <br />

                          <span style="color: gray" v-if="item.room_id === 10">
                            <b-button
                              pill
                              variant="outline-primary"
                              class="b-between"
                              v-if="!showAcc[index]"
                              @click="showAccessoriesMore(index)"
                              size="sm"
                            >
                              อุปกรณ์
                            </b-button>
                            <b-button
                              pill
                              variant="outline-danger"
                              class="b-between"
                              v-if="showAcc[index]"
                              @click="showAccessoriesLess(index)"
                              size="sm"
                            >
                              ปิด
                            </b-button>
                            <br />
                          </span>
                        </div>
                      </div>

                      <span style="color: gray" v-if="item.room_id === 10">
                        <br />
                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/micrec.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;ชุดไมค์บันทึกเสียง
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 2 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/comrec.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 3 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/headphone.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;ชุดหูฟัง </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                          </div>
                        </span>
                      </span>
                    </div>
                    <!-- <hr /> -->
                  </div>
                </div>
                <!-- </span> -->
              </span>
              <!-- ================================================ End Teacher ================================ -->

              <!-- ================================================ Student  ====================================-->
              <span v-if="isShowstaff">
                <div class="card-input">
                  <div
                    class="card card-order-list card-margin border-0 card-service"
                    v-if="item.room_id === 10"
                  >
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-2 text-left">
                          <h6>{{ item.room_name }}</h6>
                          <!-- end -->
                          <img
                            v-if="item.room_id === 10"
                            src="../../assets/meetingrooms/rac.jpeg"
                            alt=""
                            class="zoom"
                          />
                        </div>

                        <div class="col-md-10 text-left">
                          <br />
                          <span class="text-secondary">
                            **เลือกช่วงเวลาเพื่อจอง
                            <div class="space"></div>
                          </span>
                          <div class="time-column">
                            <span
                              v-if="
                                item.status === 1 ||
                                (item.status === 0 &&
                                  item.freetimes.length === 0)
                              "
                            >
                              <b-button
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                08:30-12:00
                              </b-button>

                              <b-button
                                pill
                                variant="outline-secondary"
                                disabled
                                class="b-between"
                              >
                                13:00-16:00
                              </b-button>
                            </span>
                            <span v-for="(prod, j) of item.freetimes" :key="j">
                              <span v-if="!user">
                                <b-button
                                  v-if="
                                    item.freetimes.length === 1 &&
                                    item.status === 0 &&
                                    prod.time_begin === '13:00'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="b-between"
                                >
                                  08:30-12:00
                                </b-button>
                                <b-button
                                  v-if="
                                    item.freetimes.length === 1 &&
                                    item.status === 0 &&
                                    prod.time_begin === '16:30'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="b-between"
                                >
                                  13:00-16:30
                                </b-button>

                                <b-button
                                  pill
                                  v-if="
                                    prod.time_begin !== '08:30' ||
                                    prod.time_end !== '16:30'
                                  "
                                  variant="outline-pink"
                                  v-b-modal="
                                    'modal-meetingMain' +
                                    item.room_id +
                                    prod.time_id
                                  "
                                  class="b-between"
                                  @click="getUsefor(item.room_id)"
                                >
                                  {{ prod.time_begin }}-{{ prod.time_end }}
                                </b-button>

                                <span
                                  v-for="(timechkuse, iue) in historyall"
                                  :key="iue"
                                >
                                  <b-button
                                    pill
                                    v-if="
                                      timechkuse.room_id === item.room_id &&
                                      timechkuse.time_begin === '13:00' &&
                                      timechkuse.time_begin !==
                                        prod.time_begin &&
                                      item.freetimes.length === 1
                                    "
                                    variant="outline-secondary"
                                    disabled
                                    class="b-between"
                                  >
                                    13:00-16:30
                                  </b-button>
                                </span>
                              </span>

                              <!-- if user :login  -->
                              <span v-if="user">
                                <b-button
                                  v-if="
                                    item.freetimes.length === 1 &&
                                    item.status === 0 &&
                                    prod.time_begin === '13:00'
                                  "
                                  pill
                                  variant="outline-secondary"
                                  disabled
                                  class="b-between"
                                >
                                  08:30-12:00
                                </b-button>

                                <b-button
                                  pill
                                  v-if="
                                    prod.time_begin !== '08:30' ||
                                    (prod.time_end !== '16:30' &&
                                      item.freetimes.length !== 0)
                                  "
                                  variant="outline-pink"
                                  class="b-between"
                                  href="/login"
                                >
                                  {{ prod.time_begin }}-{{ prod.time_end }}
                                </b-button>

                                <span
                                  v-for="(timechkuser, iu) in historyall"
                                  :key="iu"
                                >
                                  <b-button
                                    pill
                                    v-if="
                                      timechkuser.room_id === item.room_id &&
                                      timechkuser.time_begin === '13:00' &&
                                      timechkuser.time_begin !==
                                        prod.time_begin &&
                                      item.freetimes.length === 1
                                    "
                                    variant="outline-secondary"
                                    disabled
                                    class="b-between"
                                  >
                                    13:00-16:30
                                  </b-button>
                                </span>
                              </span>

                              <b-modal
                                :hide-footer="true"
                                v-if="chkbookingroom"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingMain' +
                                  item.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                              >
                                <template #modal-title>
                                  <div
                                    class="card card-order-list card-margin shadow-sm border-light card-time-title"
                                  >
                                    <div class="card-body">
                                      <i class="fa-solid fa-bookmark"></i>
                                      ห้อง {{ item.room_name }} เวลาจอง
                                      {{ prod.time_begin }} -
                                      {{ prod.time_end }}
                                    </div>
                                  </div>
                                </template>
                                <div
                                  class="card card-order-list card-margin shadow-sm border-light card-time-body"
                                >
                                  <div class="card-body">
                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        booking(
                                          item.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meetingMain' +
                                            item.room_id +
                                            prod.time_id
                                        )
                                      "
                                      v-if="
                                        (auth.isLibraryStaff === 1 &&
                                          item.floor !== 6) ||
                                        auth.isLibraryStaff !== 1
                                      "
                                    >
                                      <b-form-select
                                        v-model="selected"
                                        :options="options"
                                        class="mb-3 input-style"
                                        value-field="usefor_id"
                                        text-field="usefor_name"
                                        disabled-field="notEnabled"
                                      >
                                        <template #first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                            >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                          >
                                        </template>
                                      </b-form-select>
                                      <input
                                        type="text"
                                        class="form-control input-style"
                                        placeholder="กรอกวัตถุประสงค์"
                                        v-model="input_another"
                                        v-if="
                                          selected === 7 ||
                                          selected === 13 ||
                                          selected === 16
                                        "
                                      />
                                      <p style="color: red">
                                        **หมายเหตุ : กรอกรหัสนักศึกษา
                                        {{ item.min_person }} คนขึ้นไป
                                      </p>
                                      <span
                                        style="color: red"
                                        v-if="error != '' || error === null"
                                      >
                                        **{{ error }}
                                      </span>
                                      <!-- <div class="space"></div> -->

                                      <b-row>
                                        <b-col
                                          cols="6"
                                          v-for="(stdr, index) in input_stdcode"
                                          :key="index"
                                        >
                                          <input
                                            class="form-control input-style"
                                            placeholder="กรอกรหัสนักศึกษา"
                                            maxlength="11"
                                            v-model="values[index]"
                                          />
                                        </b-col>
                                      </b-row>

                                      <button
                                        :disabled="!isComplete"
                                        type="submit"
                                        class="btn btn-orange deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </button>
                                    </form>

                                    <form
                                      class="form-group"
                                      @submit.prevent="
                                        bookingAnother(
                                          item.room_id,
                                          prod.time_begin,
                                          prod.time_end,
                                          prod.time_id,
                                          'modal-meetingMain' +
                                            item.room_id +
                                            prod.time_id
                                        )
                                      "
                                      v-if="
                                        auth.isLibraryStaff === 1 &&
                                        item.floor === 6
                                      "
                                    >
                                      <!-- Teacher -->
                                      <span>
                                        <b-button variant="outline-primary">
                                          สำหรับอาจารย์
                                        </b-button>
                                      </span>
                                      <span
                                        style="color: red; font-weight: bold"
                                        v-if="error != '' || error === null"
                                      >
                                        ERROR : {{ error }}
                                        <br />
                                        <br />
                                      </span>
                                      <b-row>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="เบอร์โทรศัพท์"
                                            maxlength="10"
                                            v-model="input_room_Teacher_phone"
                                          />
                                        </b-col>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="ชื่อ - นามสกุล"
                                            v-model="input_room_Teacher_name"
                                            autocomplete
                                          />
                                        </b-col>
                                        <!-- this.optionsfac -->
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selectedfac"
                                            :options="optionsfac"
                                            class="mb-3 input-style"
                                            value-field="fac_code"
                                            text-field="fac_name"
                                            disabled-field="notEnabled"
                                            @change="get_branch()"
                                          >
                                            <!-- Teacher -->

                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                                >เลือกคณะ</b-form-select-option
                                              >
                                            </template>
                                          </b-form-select>
                                        </b-col>
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selectedbranch"
                                            :options="optionsbranch"
                                            class="mb-3 input-style"
                                            value-field="branch_code"
                                            text-field="branch_name"
                                            disabled-field="notEnabled"
                                          >
                                            <!-- Teacher -->

                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                                >เลือกสาขา</b-form-select-option
                                              >
                                            </template>
                                          </b-form-select>
                                        </b-col>
                                        <b-col cols="6">
                                          <input
                                            class="form-control input-style"
                                            placeholder="อีเมล"
                                            maxlength=""
                                            v-model="input_room_Teacher_email"
                                            type="email"
                                          />
                                        </b-col>
                                        <b-col cols="6">
                                          <b-form-select
                                            v-model="selected"
                                            :options="options"
                                            class="mb-3 input-style"
                                            value-field="usefor_id"
                                            text-field="usefor_name"
                                            disabled-field="notEnabled"
                                          >
                                            <!-- Teacher -->

                                            <template #first>
                                              <b-form-select-option
                                                :value="null"
                                                disabled
                                                >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                              >
                                            </template>
                                          </b-form-select>
                                          <input
                                            type="text"
                                            class="form-control input-style"
                                            placeholder="กรอกวัตถุประสงค์"
                                            v-model="input_another"
                                            v-if="
                                              selected === 7 ||
                                              selected === 13 ||
                                              selected === 16
                                            "
                                          />
                                        </b-col>
                                      </b-row>

                                      <!-- :disabled="!isComplete" -->
                                      <button
                                        v-if="
                                          auth.isLibraryStaff === 1 &&
                                          item.floor === 6
                                        "
                                        :disabled="!isCompleteAnothor"
                                        type="submit"
                                        class="btn btn-orange deep-purple btn-block badge-pill"
                                        data-dismiss="modal"
                                        @click="showModal = false"
                                      >
                                        ยืนยัน
                                      </button>
                                    </form>
                                  </div>
                                </div>
                              </b-modal>

                              <b-modal
                                :hide-footer="true"
                                :hide-header="true"
                                centered
                                size="lg"
                                :id="
                                  'modal-meetingMain' +
                                  item.room_id +
                                  prod.time_id
                                "
                                header-border-variant="white"
                                class="border-bottom-0"
                                v-if="!chkbookingroom"
                              >
                                <div
                                  class="card-body justify-content-center card-block p-3 text-center text-danger"
                                >
                                  <h5>
                                    <i
                                      class="fa-solid fa-circle-exclamation"
                                    ></i>
                                    {{ msgbookingroom }}
                                  </h5>
                                </div>
                              </b-modal>
                            </span>
                          </div>
                          <br />

                          <span style="color: gray">
                            <b-button
                              pill
                              variant="outline-primary"
                              class="b-between"
                              v-if="!showAcc[index]"
                              @click="showAccessoriesMore(index)"
                              size="sm"
                            >
                              อุปกรณ์
                            </b-button>
                            <b-button
                              pill
                              variant="outline-danger"
                              class="b-between"
                              v-if="showAcc[index]"
                              @click="showAccessoriesLess(index)"
                              size="sm"
                            >
                              ปิด
                            </b-button>
                            <br />

                            <!-- End -->
                          </span>
                        </div>
                      </div>

                      <span style="color: gray" v-if="item.room_id === 10">
                        <br />
                        <span v-if="showAcc[index]">
                          <div class="card-columns-left-item">
                            <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/micrec.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;ชุดไมค์บันทึกเสียง
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 2 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/comrec.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span>
                                      &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                    </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                            <!-- 3 -->
                            <div
                              class="card card-order-list card-margin border-light shadow"
                            >
                              <div class="card-body text-left">
                                <b-row>
                                  <b-col cols="2">
                                    <img
                                      src="./../../assets/meetingrooms/headphone.jpeg"
                                      alt=""
                                      width="40"
                                      height="auto"
                                    />
                                  </b-col>
                                  <b-col cols="10">
                                    <span> &nbsp;&nbsp;ชุดหูฟัง </span>
                                  </b-col>
                                </b-row>
                              </div>
                            </div>
                          </div>
                        </span>
                      </span>
                    </div>
                    <!-- <hr /> -->
                    <!-- v-if="item.status === 0" -->
                  </div>

                  <div></div>
                </div>
              </span>
              <!-- ================================================ End student ================================ -->
              <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ END MAIN ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->

              <!-- ######################################################  2 Culums #################################################################  -->

              <!-- ######################################################  END  2 Culums ########################################################### -->
            </div>
          </div>
        </div>
        <!-- ================================== END RACORD ============================================== -->
      </b-container>
    </section>
  </div>
</template>

<script>
import sidebar_user from "../layouts/sidebar_user.vue";
import $ from "jquery";
import axios from "axios";

import VueHorizontalCalendar from "vue-horizontal-calendar";

import moment from "moment";
export default {
  name: "meetingroom",
  components: { sidebar_user, VueHorizontalCalendar },
  data() {
    return {
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      tokenjong: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      checked: true,
      auth: [],
      radio_btn: "",
      items: [],
      orders: [],
      value: "",
      hideRoom: false,
      slide: 0,
      sliding: null,
      dateTime: new Date(),
      choosedDay2: {
        dateFormat: "",
        year: "",
        month: "",
        date: "",
        day: "",
        timestamp: "",
      },
      showModal: false,
      status_room: [],
      input_stdcode: [{}],
      code: "",
      date: "",
      selected: null,
      selected2: null,
      selected3: null,
      options: [],
      optionsfac: [],
      selectedfac: null,
      optionsbranch: [],
      selectedbranch: null,
      dbroom: [],
      dbroomMax: "",
      dbroomMin: "",
      stdr: [],
      values: {},
      res: [],
      error: "",
      status_show: false,
      input_another: "",
      isShowstaff: false,
      input_room_Teacher: {
        phone: "",
        name: "name",
        fac: "",
        branch: "",
        email: "",
      },
      input_room_Teacher_name: "",
      input_room_Teacher_phone: "",
      input_room_Teacher_fac: "",
      input_room_Teacher_branch: "",
      input_room_Teacher_email: "",
      fac_code: "",
      branch_code: "",
      user: false,
      history: [],
      list: [],
      readMore: {},
      historyall: [],
      showAcc: {},
      chkbookingroom: "",
      chkDate: [],
      msgbookingroom: "",
      // show_input_teacher: false,
    };
  },
  mounted() {
    this.getHistoryAll();
    this.getIP();
    this.get_fac();
    if (localStorage.getItem("auth") != null) {
      this.getorders();
      this.user = false;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;

      // console.log(this.input_room_Teacher.name);
      if (this.auth.user_type === "Teacher" || this.auth.isLibraryStaff === 0) {
        this.isShowstaff;
        this.input_room_Teacher_name = this.auth.std_name;
        this.fac_code = this.auth.fac_code;
        this.branch_code = this.auth.branch_code;
        (this.input_room_Teacher_phone = this.code),
          (this.input_room_Teacher_email = "");
        this.input_room_Teacher_fac = this.auth.fac_name;
        this.input_room_Teacher_branch = this.auth.branch_name;
      } else if (this.auth.user_type === "Student") {
        this.isShowstaff = true;
      }

      if (this.auth.isLibraryStaff === 1) {
        this.staff = true;
        this.input_room_Teacher_name = "";
        this.fac_code = "";
        this.branch_code = "";
        (this.input_room_Teacher_phone = ""),
          (this.input_room_Teacher_email = "");
        this.input_room_Teacher_fac = "";
        this.input_room_Teacher_branch = "";
      } else {
        this.staff = false;
      }

      if (localStorage.getItem("orders") != null) {
        this.loadOrder();
      }
    } else {
      this.user = true;
      this.isShowstaff = true;
    }

    if (localStorage.getItem("booking") != null) {
      this.loadBooking();
    }

    //
    window.setTimeout(function () {
      $(".alert")
        .fadeTo(500, 0)
        .slideUp(500, function () {
          $(this).remove();
        });
    }, 3000);
    //

    // this.getHistory();
    setInterval(() => {
      this.getRoom();
      this.getHistory();
    }, 15000);

    $("#deployform").click(function () {
      $(this).addClass("open");
    });

    $(".cancel").click(function (e) {
      $(this).parent().removeClass("open");
      e.stopPropagation();
    });
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      return moment(date).add(543, "year").format("LL");
    },
  },
  methods: {
    onChange() {
      // console.log(this.radio_btn);
    },
    get_branch() {
      const token = this.tokenjong;
      let data = {
        token: token,
        fac_code: this.selectedfac,
      };
      console.log(data);
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/room/get_branch_withfac",
          data,
          {
            headers,
          }
        )
        .then((res) => {
          this.optionsbranch = res.data.branches;
        });
    },
    get_fac() {
      const token = this.tokenjong;
      let data = {
        token: token,
        search_with_fac_code: "",
      };
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/get_faculty", data, {
          headers,
        })
        .then((res) => {
          this.optionsfac = res.data.faculties;
        });
    },
    showAccessoriesMore(id) {
      this.$set(this.showAcc, id, true);
    },
    showAccessoriesLess(id) {
      this.$set(this.showAcc, id, false);
    },

    showMore(id) {
      this.$set(this.readMore, id, true);
      // if(id){
      //   this.readMore= true;
      // }
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    getIP() {
      this.getIPAddress().then((res) => {
        this.ipAddress = res.data.ip;
        localStorage.setItem("IP", this.ipAddress);
      });
    },
    getIPAddress() {
      return axios.get("https://api.ipify.org/?format=json");
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    addFind() {
      this.stdr.push({ value: "" });
      // console.log("v modal ==", this.stdr);
    },
    ctrlShiftkey(e, keyCode) {
      return e.ctrlKey && e.shiftKey && e.keyCode == keyCode.charCodeAt(0);
    },
    getorders() {
      let c = JSON.parse(localStorage.getItem("auth"));
      let data = {
        token: this.token,
        std_code: c.std_code,
      };
      const headers = {
        "content-type": "application/json",
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
          } else {
            if (res.data.Orders !== null) {
              this.orders = res.data.Orders;
              for (var i in this.orders) {
                if (this.orders[i].order_status === 5) {
                  this.orders.splice(this.orders.indexOf(this.orders[i]), 1);
                }
              }

              localStorage.setItem("orders", JSON.stringify(this.orders));
              this.show = true;
            }
          }
        });
    },
    getUsefor(roomId) {
      this.showModal = true;
      this.selected = null;
      this.error = "";
      this.input_another = "";
      this.res = [];
      this.input_room_Teacher.phone = "";
      this.input_room_Teacher.name = "";
      this.input_room_Teacher.fac = null;
      this.input_room_Teacher.branch = null;
      this.input_room_Teacher.email = "";

      let data = {
        room_id: roomId,
      };
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/step2_getusefor", data, {
          headers,
        })
        .then((res) => {
          this.dbroom = res.data.room;
          this.options = res.data.data;
          this.dbroomMax = res.data.room[0].max_person;
          this.dbroomMin = res.data.room[0].min_person;
          this.input_stdcode = [{}];
          this.values = {};
          for (var i = 1; i < this.dbroomMax; i++) {
            this.input_stdcode.push({ std: "" });
          }
        });
    },
    getRoom() {
      this.list = [];
      if (localStorage.getItem("auth") != null) {
        this.user = false;
        this.auth = JSON.parse(localStorage.getItem("auth"));
        this.code = this.auth.std_code;
        // console.log(this.auth);
        if (this.auth.user_type === "Teacher") {
          this.isShowstaff;
          // console.log("Teacher");
        } else if (
          this.auth.user_type === "Student" ||
          this.auth.isLibraryStaff != 0
        ) {
          this.isShowstaff = true;
          // console.log("Student");
        }

        if (this.auth.isLibraryStaff === 1) {
          this.staff = true;
        } else {
          this.staff = false;
        }

        if (localStorage.getItem("orders") != null) {
          this.loadOrder();
        }
      } else {
        this.user = true;
        this.isShowstaff = true;
        // console.log("anothor");
      }

      let data = {
        select_date: this.choosedDay2.dateFormat,
        test_code: this.code,
      };
      // console.log("datetime ====", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.getHistory();
      // this.$isLoading(true);
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/step1_getroom_status",
          data,
          { headers }
        )
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            // this.$isLoading(false);
            alert(res.data.msg.message);
          } else {
            // this.$isLoading(false);
            this.status_room = res.data.room_status;
            // console.log(this.status_room);
            this.histories = res.data.histories;
            this.status_room.forEach((item) => {
              if (item.freetimes.length !== 0) {
                this.list.push(item);
              }
              // console.log("chk", item, index);
            });
            // console.log("Room ", this.list);
          }
        });
    },
    getHistory() {
      // console.log(this.choosedDay2);
      // this.dateChange2(this.choosedDay2);
      let data = {
        select_date: this.choosedDay2.dateFormat,
        std_code: this.code,
      };
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/get_history_per_std", data, {
          headers,
        })
        .then((res) => {
          // console.log("res history==", res.data.is_can_i_booking
          // );

          // this.statsut_show =  false;
          if (this.auth.length !== 0) {
            // console.log("code",this.auth);
            if (res.data.msg.status === 200) {
              this.history = res.data.histories;
              // this.chkbookingroom = true;
              this.chkbookingroom = res.data.is_can_i_booking;
              this.msgbookingroom = res.data.is_can_i_booking_msg;
              if (this.history.length === 0) {
                this.status_show = false;
              } else {
                this.status_show = true;
              }
            } else {
              alert(res.data.msg.message);
            }
          } else {
            // console.log("No code");
            this.status_show = false;
          }

          // if (
          //   this.history.trans_status !== "booked" ||
          //   this.history.trans_status !== "endofuse"
          // ) {
          //   // console.log("booked", this.chkbookingroom);
          //   this.status_show = true;
          // }
        });
      // getroom
    },
    loadOrder() {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    },
    loadBooking() {
      this.items = JSON.parse(localStorage.getItem("booking"));
    },

    onContext(ctx) {
      this.context = ctx;
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    dateChange2(day) {
      // console.log("data day To",day);
      // this.chkDate = day;
      // console.log("checkdat",this.checkDate);
      this.list = [];
      if (localStorage.getItem("auth") != null) {
        this.user = false;
        this.auth = JSON.parse(localStorage.getItem("auth"));
        this.code = this.auth.std_code;
        // console.log(this.auth);
        if (this.auth.user_type === "Teacher") {
          this.isShowstaff;
          // console.log("Teacher");
        } else if (
          this.auth.user_type === "Student" ||
          this.auth.isLibraryStaff != 0
        ) {
          this.isShowstaff = true;
          // console.log("Student");
        }

        if (this.auth.isLibraryStaff === 1) {
          this.staff = true;
        } else {
          this.staff = false;
        }

        if (localStorage.getItem("orders") != null) {
          this.loadOrder();
        }
      } else {
        this.user = true;
        this.isShowstaff = true;
        // console.log("anothor");
      }

      this.choosedDay2 = day;
      this.date = this.choosedDay2.dateFormat;
      let data = {
        select_date: this.choosedDay2.dateFormat,
        test_code: this.code,
      };
      // console.log("datetime ====", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.getHistory();
      this.$isLoading(true);
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/step1_getroom_status",
          data,
          { headers }
        )
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            this.$isLoading(false);
            alert(res.data.msg.message);
          } else {
            this.$isLoading(false);
            this.status_room = res.data.room_status;
            // console.log(this.status_room);
            this.histories = res.data.histories;
            this.status_room.forEach((item) => {
              if (item.freetimes.length !== 0) {
                this.list.push(item);
              }
              // console.log("chk", item, index);
            });
            // console.log("Room ", this.list);
          }
        });
    },
    booking(room_id, time_begin, time_end, time_id, id) {
      // console.log(" another ==", this.input_another);
      this.list = [];

      let ip = localStorage.getItem("IP");

      for (var key of Object.keys(this.values)) {
        this.res.push(this.values[key]);
      }

      let data = {
        select_date: this.choosedDay2.dateFormat,
        room_id: room_id,
        time_id: time_id,
        time_begin: time_begin,
        time_end: time_end,
        usefor_id: this.selected,
        usefor_title: this.input_another,
        std_code: this.res,
        public_ip: ip,
        whois_std_code: this.code,
        isteacher: false,
      };
      // console.log("Booking",data,id);
      console.log("Booking ===", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/step3_confirm", data, {
          headers,
        })
        .then((res) => {
          console.log(" booking ==", res.data);
          if (res.data.msg.status === 200) {
            this.$isLoading(false);
            this.status_room = res.data.room_status;
            if (this.auth.length !== 0) {
              this.status_show = true;
            } else {
              this.status_show = false;
            }

            this.getHistory();
            // this.histories = res.data.histories;
            this.$bvModal.hide(id);
            this.status_room.forEach((item) => {
              if (item.freetimes.length !== 0) {
                this.list.push(item);
              }
              // console.log("chk", item, index);
            });
            //  router.push('/meetingRoom');
            // console.log("true Booking ");
          } else {
            this.$isLoading(false);
            this.error = res.data.msg.message;
            this.res = [];
          }

          // console.log(res.data);
        });
    },
    bookingAnother(room_id, time_begin, time_end, time_id, id) {
      this.list = [];
      let data;
      let ip = localStorage.getItem("IP");

      for (var key of Object.keys(this.values)) {
        this.res.push(this.values[key]);
      }
      if (this.auth.isLibraryStaff === 1) {
        data = {
          select_date: this.choosedDay2.dateFormat,
          room_id: room_id,
          time_id: time_id,
          time_begin: time_begin,
          time_end: time_end,
          usefor_id: this.selected,
          usefor_title: this.input_another,
          std_code: this.res,
          public_ip: ip,
          whois_std_code: this.code,
          teach_name: this.input_room_Teacher_name,
          teach_tel: this.input_room_Teacher_phone,
          teach_email: this.input_room_Teacher_email,
          fac_code: this.selectedfac,
          branch_code: this.selectedbranch,
          isteacher: true,
        };
      } else {
        data = {
          select_date: this.choosedDay2.dateFormat,
          room_id: room_id,
          time_id: time_id,
          time_begin: time_begin,
          time_end: time_end,
          usefor_id: this.selected,
          usefor_title: this.input_another,
          std_code: this.res,
          public_ip: ip,
          whois_std_code: this.code,
          teach_name: this.input_room_Teacher_name,
          teach_tel: this.input_room_Teacher_phone,
          teach_email: this.input_room_Teacher_email,
          fac_code: this.fac_code,
          branch_code: this.branch_code,
          isteacher: true,
        };
      }

      // console.log("Booking",data);
      // console.log("Booking Anthor===", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/step3_confirm", data, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status === 200) {
            this.$isLoading(false);
            this.status_room = res.data.room_status;
            if (this.auth.length !== 0) {
              this.status_show = true;
            } else {
              this.status_show = false;
            }
            // this.status_show = true;
            this.getHistory();
            this.histories = res.data.histories;
            this.$bvModal.hide(id);
            this.status_room.forEach((item) => {
              if (item.freetimes.length !== 0) {
                this.list.push(item);
              }
              // console.log("chk", item, index);
            });
            //  router.push('/meetingRoom');
            // console.log("true Booking ");
          } else {
            this.$isLoading(false);
            this.error = res.data.msg.message;
            this.res = [];
          }
        });

      // console.log(this.input_room_Teacher);
      // this.$bvModal.hide(id);
    },
    getHistoryAll() {
      let data = {
        select_date: this.choosedDay2.dateFormat,
        test_code: this.code,
      };
      // console.log("get story data ==", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/get_history_all", data, {
          headers,
        })
        .then((res) => {
          // console.log("res historyAll==", res);
          if (this.auth.length !== 0) {
            if (res.data.msg.status === 200) {
              this.historyall = res.data.histories;
              if (this.history.length === 0) {
                this.status_show = false;
              } else {
                this.status_show = true;
              }
            } else {
              alert(res.data.msg.message);
            }
          } else {
            this.status_show = false;
          }
        });
    },
    cancelRoom(val) {
      console.log(val);
    },
    // showInputTeacher() {
    //   this.show_input_teacher = true;
    // },
    // closeInputTeacher() {
    //   this.show_input_teacher = false;
    // },
  },
  computed: {
    // selected === 7 ||
    //                                           selected === 13 ||
    //                                           selected === 16
    isComplete() {
      var t;
      if (
        this.selected === 7 ||
        this.selected === 13 ||
        (this.selected === 16 && this.selected !== null)
      ) {
        t =
          (this.values[0] &&
            this.values[1] &&
            this.selected &&
            this.input_another) ||
          (this.values[0] &&
            this.values[2] &&
            this.selected &&
            this.input_another);
      } else {
        t =
          (this.values[0] && this.values[1] && this.selected) ||
          (this.values[0] && this.values[2] && this.selected);
      }
      return t;
    },
    isCompleteTeach() {
      var te;
      if (
        this.selected === 7 ||
        this.selected === 13 ||
        (this.selected === 16 && this.selected !== null)
      ) {
        te = this.selected && this.input_another;
      } else {
        te = this.selected;
      }
      return te;
    },
    isCompleteAnothor() {
      var s;
      if (
        this.selected === 7 ||
        this.selected === 13 ||
        (this.selected === 16 && this.selected !== null)
      ) {
        s =
          this.input_room_Teacher_name &&
          this.input_room_Teacher_phone &&
          this.selectedfac &&
          this.selectedbranch &&
          this.input_room_Teacher_email &&
          this.selected &&
          this.input_another;
      } else {
        s =
          this.input_room_Teacher_name &&
          this.input_room_Teacher_phone &&
          this.selectedfac &&
          this.selectedbranch &&
          this.input_room_Teacher_email &&
          this.selected;
      }

      return s;
    },
  },
};
</script>

<style lang="scss" scoped>
.home-section {
  position: relative;
  background: var(--greyLight-1);
  min-height: 100vh;
  top: 0;
  left: 78px;
  width: calc(100% - 78px);
  transition: all 0.5s ease;
  z-index: 2;
}
.sidebar.open ~ .home-section {
  left: 250px;
  width: calc(100% - 250px);
}
.home-section .text {
  display: inline-block;
  color: #11101d;
  font-size: 25px;
  font-weight: 500;
  margin: 18px;
}
.space {
  height: 30px;
}
/* card date */
.calendar-list .card {
  border-radius: 20px;
}

.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
.shadow-date {
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}

.room-name {
  margin-left: 0px;
}
.card-header:first-child {
  /* border-radius: 0px; */
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.card-columns .card {
  border-radius: 20px;
}
.calendar-list .card {
  border-radius: 20px;
}
.card-content-more {
  position: relative;
  color: orangered;
  font-weight: bold;
}

/*END*/
/* ORDER LIST book  room*/
.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}

.card-title {
  text-align: left;
  text-align: justify;
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  margin-bottom: -5px;
}
.text-muted i {
  margin: 0 5px;
}

.calendar-list .card {
  border-radius: 20px;
}

.horizontal-calendar {
  border-top: 0px !important;
  border: 0px;
}
.b-between {
  margin-right: 5px !important;
  margin-bottom: 5px;
}

.card .card_image {
  width: inherit;
  height: inherit;
  border-radius: 20px;
}

.card .card_image img {
  width: inherit;
  height: inherit;
  border-radius: 20px;
  object-fit: cover;
}
.card-status-booking {
  top: 1rem;
  margin-left: 9.5rem;
}
.zoom {
  padding: 25px;
  /* background-color: green; */
  transition: transform 0.2s;
  width: 160px;
  height: auto;
  margin: 0 auto;
  margin-left: -20px;
}

.zoom:hover {
  -ms-transform: scale(1.5); /* IE 9 */
  -webkit-transform: scale(1.5); /* Safari 3-8 */
  transform: scale(1.5);
}
.text-space {
  height: 50px;
}
.hidden {
  display: none;
}

/* card */
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
  .card-room {
    column-count: 1;
  }
  .card-colum-me {
    column-count: 1;
  }
  .time-column {
    column-count: 2;
  }
  h6 {
    margin-top: 10px;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
  .card-room {
    column-count: 1;
  }
  .card-colum-me {
    column-count: 1;
  }
  .time-column {
    column-count: 2;
  }
  h6 {
    margin-top: 10px;
  }

  .on-line {
    width: 6%;
    height: auto;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
  .card-room {
    column-count: 1;
  }
  .card-colum-me {
    column-count: 1;
  }
  .time-column {
    column-count: 2;
  }
  h6 {
    margin-top: 10px;
  }
  .on-line {
    /* width: 8%; */
    height: auto;
  }
  .card-columns-left-item {
    column-count: 2;
  }
}

@media (max-width: 667px) {
  .on-line {
    width: 11%;
    height: auto;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}
/*End*/

/*  CHIP new order */
.chip_job {
  grid-column: 2/3;
  grid-row: 3/4;
  justify-self: center;
  width: 15rem;
  height: 3rem;
  border-radius: 1rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chip {
  grid-column: 2/3;
  grid-row: 3/4;
  justify-self: center;
  width: 15rem;
  height: 3rem;
  border-radius: 1rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  /*box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);*/
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chip__icon {
  width: 3rem;
  height: 3rem;
  border-radius: 1rem;
  margin: 0 0 0 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: green;
}
.chip_job p {
  font-size: 1.3rem;
  margin-right: 6.4rem;
  margin-top: 1rem;
  color: var(--greyDark);
  font-weight: bold;
}
.chip p {
  font-size: 1rem;
  margin-right: 4rem;
  margin-top: 1rem;
  color: var(--greyDark);
  font-weight: bold;
}
.chip__close {
  width: 1.6rem;
  height: 1.6rem;
  margin: 0 2rem;
  display: flex;
  font-size: 1rem;
  color: var(--greyLight-3);
  cursor: pointer;
}
/*END */

/* tebs content */
.tebs_content {
  position: relative;
}
.tebs_floting {
  position: absolute;
  top: 0rem;
  left: 0rem;
  font-size: 14px;
}

.segmented-control {
  grid-column: 3/4;
  grid-row: 1/2;
  width: 20.5rem;
  height: 3.4rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  position: relative;
  left: 0rem;
  top: 0rem;
}
.segmented-control input {
  display: none;
}
.segmented-control > input:checked + label {
  transition: all 0.5s ease;
  color: rgb(209, 95, 2);
}
.segmented-control__1,
.segmented-control__2,
.segmented-control__3 {
  width: 7rem;
  height: 3.6rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #ff5f2d;
  transition: all 0.5s ease;
  margin-top: 1.5rem;
}
.segmented-control__1:hover,
.segmented-control__2:hover,
.segmented-control__3:hover {
  color: rgb(209, 95, 2);
}
.segmented-control__color {
  position: absolute;
  height: 2.5rem;
  width: 7rem;
  margin-left: 0.3rem;
  border-radius: 0.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  pointer-events: none;
}

#tab-1:checked ~ .segmented-control__color {
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-2:checked ~ .segmented-control__color {
  transform: translateX(6.4rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-3:checked ~ .segmented-control__color {
  transform: translateX(13rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/* end*/
/*btn color */
.btn-orange {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange-color);
}

.btn-orange:hover {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange-color);
}
.btn-orange:focus,
.btn-orange.focus {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange-color);
  box-shadow: 0 0 0 0.2rem rgba(180, 72, 112, 0.5);
}
.btn-orange.disabled,
.btn-orange:disabled {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange-color);
}
.btn-orange:not(:disabled):not(.disabled):active,
.btn-orange:not(:disabled):not(.disabled).active,
.show > .btn-orange.dropdown-toggle {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--sub-color);
}
.btn-orange:not(:disabled):not(.disabled):active:focus,
.btn-orange:not(:disabled):not(.disabled).active:focus,
.show > .btn-orange.dropdown-toggle:focus {
  /*rgba(180, 72, 112, 0.5);*/
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}

/*  */

.btn-outline-pink {
  /*#ed3d6f*/
  color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}
.btn-outline-pink:hover {
  color: #fff;
  border-color: rgb(255, 95, 45);
  background-color: rgb(255, 95, 45);
}
.btn-outline-pink:focus,
.btn-outline-pink.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
.btn-outline-pink.disabled,
.btn-outline-pink:disabled {
  color: #000000;
  background-color: transparent;
}
.btn-outline-pink:not(:disabled):not(.disabled):active,
.btn-outline-pink:not(:disabled):not(.disabled).active,
.show > .btn-outline-pink.dropdown-toggle {
  color: #fff;
  border-color: #000000;
  background-color: #000000;
}
.btn-outline-pink:not(:disabled):not(.disabled):active:focus,
.btn-outline-pink:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-pink.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}

.form-group input {
  margin-bottom: 20px;
}
.form-group button {
  margin-bottom: 20px;
}
#button {
  border-radius: 30px;
}

.input-style {
  border-radius: 30px;
  background-color: #ffffff;
  border-color: #cecece;
  color: #000000;
}

.card-service {
  background-color: var(--greyLight-3);

  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-3),
    -0.2rem -0.2rem 1.8rem var(--white);
  background: none;
  font-family: inherit;
}
/*end*/

/* Room booked*/

/**/

/*Overtime*/
.overtime {
  grid-column: 2/3;
  grid-row: 3/4;
  justify-self: center;
  width: 15rem;
  height: 3rem;
  border-radius: 1rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.overtime_icon {
  width: 3rem;
  height: 3rem;
  border-radius: 1rem;
  margin: 0 0 0 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: orangered;
}
.overtime p {
  font-size: 1rem;
  margin-right: 4rem;
  margin-top: 1rem;
  color: var(--greyDark);
  font-weight: bold;
}
.overtime-detail {
  margin-bottom: 0px;
  margin-top: 0px;
}

/*END*/
</style>
